<template>
  <div class="dashboard">
    <div class="main-content">
      <navbar-dashboard name="Gestión de Recolecciones" />

      <div class="ew-view">
        <page-header title="Recolecciones" subtitle="Programa y consulta las recolecciones de tus envíos.">
          <b-button variant="primary" @click="showRecoleccionModal">
            <i class="bi bi-plus-lg mr-1"></i> Nueva recolección
          </b-button>
        </page-header>

        <!-- Tabla de Recolecciones -->
        <div class="ew-table-scroll mb-4">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th>Paquetería</th>
                <th>Fecha de recolección</th>
                <th>Contacto</th>
                <th>Teléfono</th>
                <th>N° de confirmación</th>
                <th>Instrucciones</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="isLoading">
                <tr v-for="n in 5" :key="'sk-' + n">
                  <td v-for="c in 7" :key="c"><span class="ew-skeleton"></span></td>
                </tr>
              </template>
              <tr v-for="r in recolecciones" v-else :key="r._id || r.id">
                <td class="font-weight-bold">{{ r.carrier | carrierName }}</td>
                <td class="text-nowrap">{{ formatDate(r.pickupDate) }}</td>
                <td>{{ r.pickupContact && r.pickupContact.personName | dash }}</td>
                <td class="text-nowrap">{{ r.pickupContact && r.pickupContact.phone | dash }}</td>
                <td class="text-nowrap">{{ confirmationLabel(r) }}</td>
                <td class="ew-instructions" :title="r.specialInstructions">{{ r.specialInstructions | dash }}</td>
                <td class="text-center">
                  <button class="btn btn-sm btn-outline-danger ew-icon-btn" @click="showCancelacionModal(r)"
                    v-b-tooltip.hover.top="'Cancelar esta recolección'" aria-label="Cancelar recolección">
                    <i class="bi bi-x-circle"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="!isLoading && !recolecciones.length">
                <td colspan="7" class="p-0">
                  <empty-state icon="bi bi-truck" title="Aún no tienes recolecciones"
                    text="Programa una recolección para que la paquetería pase por tus envíos.">
                    <b-button variant="primary" size="sm" @click="showRecoleccionModal">
                      <i class="bi bi-plus-lg mr-1"></i> Nueva recolección
                    </b-button>
                  </empty-state>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Modal Generar Recolección -->
        <b-modal id="recoleccion-modal" v-model="showRecoleccionModalState" title="Generar Solicitud de Recolección"
          size="xl" hide-footer>

          <b-alert v-if="recoleccionResponse" variant="success" show>
            ¡Recolección solicitada con éxito! ID:
            <strong>{{ recoleccionResponse.recoleccionId || 'N/A' }}</strong>
          </b-alert>

          <b-alert v-if="recoleccionError" variant="danger" show>
            Error: {{ recoleccionError.message || recoleccionError }}
          </b-alert>

          <b-form @submit.prevent="generarRecoleccion">
            <p class="text-muted small">
              Ingresa los datos para crear una recolección.
            </p>
            <!-- Transportista -->
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label class="text-danger">Transportista *</label>
                  <b-form-select v-model="recoleccionData.carrier" required>
                    <option v-for="c in carriers" :key="c" :value="c">{{ c }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Número de guía">
                  <b-input-group>
                    <b-form-input v-model="trackingSearch" placeholder="Ingresa número de guía"></b-form-input>

                    <b-input-group-append>
                      <b-button variant="primary" @click="buscarGuia" v-b-tooltip.hover.top="'Buscar guía'">
                        Buscar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Fechas -->
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label class="text-danger">Fecha de Recolección *</label>
                  <b-form-input type="date" v-model="recoleccionData.pickupDate" required />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label class="text-danger">Listo a las *</label>
                  <b-form-input type="time" v-model="recoleccionData.readyByTime" required />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label class="text-danger">Cierre *</label>
                  <b-form-input type="time" v-model="recoleccionData.closeTime" required />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Instrucciones -->
            <b-form-group label="Instrucciones Especiales">
              <b-form-textarea v-model="recoleccionData.specialInstructions" rows="2"
                placeholder="Ejemplo: Llamar antes de llegar o dejar en recepción" />
            </b-form-group>

            <!-- Contacto -->
            <h6 class="mt-4 mb-2">Contacto de Recolección</h6>

            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label class="text-danger">Nombre *</label>
                  <b-form-input v-model="recoleccionData.pickupContact.personName" required />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label class="text-danger">Teléfono *</label>
                  <b-form-input v-model="recoleccionData.pickupContact.phone" required />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label class="text-danger">Email *</label>
                  <b-form-input type="email" v-model="recoleccionData.pickupContact.email" required />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Dirección -->
            <h6 class="mt-4 mb-2">Lugar de Recolección</h6>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label class="text-danger">Nombre de la Empresa *</label>
                  <b-form-input v-model="recoleccionData.place.companyName" required
                    :readonly="addressFieldsDisabled" />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label class="text-danger">Calle *</label>
                  <b-form-input v-model="recoleccionData.place.address1" required :readonly="addressFieldsDisabled" />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label class="text-danger">Número Exterior *</label>
                  <b-form-input v-model="recoleccionData.place.numExt" required :readonly="addressFieldsDisabled" />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Colonia / Dirección 2">
                  <b-form-input v-model="recoleccionData.place.address2" :readonly="addressFieldsDisabled" />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label class="text-danger">Ciudad *</label>
                  <b-form-input v-model="recoleccionData.place.city" required :readonly="addressFieldsDisabled" />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label class="text-danger">Estado *</label>
                  <b-form-input v-model="recoleccionData.place.stateSort" required :readonly="addressFieldsDisabled" />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label class="text-danger">Código Postal *</label>
                  <b-form-input v-model="recoleccionData.place.postalCode" required :readonly="addressFieldsDisabled" />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Ubicación del Paquete">
                  <b-form-input v-model="recoleccionData.place.packageLocation" />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Referencias">
                  <b-form-input v-model="recoleccionData.place.references" :readonly="referenceFieldDisabled" />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Paquetes -->
            <h6 class="mt-4 mb-2">Detalles de los Paquetes</h6>

            <div v-for="(parcel, index) in recoleccionData.parcels" :key="index" class="border p-3 mb-3 rounded">
              <b-row>
                <b-col md="2">
                  <b-form-group>
                    <label class="text-danger">Alto (cm) *</label>
                    <b-form-input type="number" min="0" v-model.number="parcel.height" required />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group>
                    <label class="text-danger">Ancho (cm) *</label>
                    <b-form-input type="number" min="0" v-model.number="parcel.width" required />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group>
                    <label class="text-danger">Largo (cm) *</label>
                    <b-form-input type="number" min="0" v-model.number="parcel.depth" required />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group>
                    <label class="text-danger">Peso (kg) *</label>
                    <b-form-input type="number" step="0.1" min="0" v-model.number="parcel.weight" required />
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group>
                    <label class="text-danger">Guía *</label>
                    <b-form-input type="text" v-model="parcel.trackings" required />
                  </b-form-group>
                </b-col>
                <b-col md="1" class="d-flex align-items-end justify-content-center">
                  <b-button v-if="recoleccionData.parcels.length > 1" variant="outline-danger" size="sm"
                    @click="eliminarParcel(index)" v-b-tooltip.hover.top="'Eliminar este paquete'">
                    <i class="bi bi-trash-fill"></i>
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div class="text-right mb-3">
              <b-button variant="outline-primary" size="sm" @click="agregarParcel"
                v-b-tooltip.hover.top="'Agregar paquete'">
                <i class="bi bi-plus-lg"></i> Agregar paquete
              </b-button>
            </div>
            <!-- Botones -->
            <div class="text-right mt-4">
              <b-button variant="light" class="mr-2" @click="hideRecoleccionModal"
                v-b-tooltip.hover.top="'Cerrar modal de recolección'">
                Cerrar
              </b-button>

              <b-button variant="primary" type="submit">
                Enviar Solicitud
              </b-button>
            </div>

          </b-form>
        </b-modal>

        <!-- Modal Cancelar Recolección --><b-modal id="cancelacion-modal" v-model="showCancelacionModalState"
          title="Cancelar Recolección" size="md" hide-footer>
          <b-alert v-if="cancelacionResponse" variant="success" show>
            ¡Cancelación exitosa! {{ cancelacionResponse.message }}
          </b-alert>

          <b-alert v-if="cancelacionError" variant="danger" show>
            Error: {{ cancelacionError.message || cancelacionError }}
          </b-alert>

          <b-form @submit.prevent="eliminarRecoleccion" class="mt-3">
            <p class="text-muted small">Completa los datos para cancelar una recolección.</p>

            <b-form-group label="Transportista">
              <b-form-select v-model="cancelacionData.carrier" required
                v-b-tooltip.hover.top="'Selecciona la empresa transportista del envío'">
                <option value="">Selecciona un transportista...</option>
                <option v-for="c in carriers" :key="c" :value="c">{{ c }}</option>
              </b-form-select>
            </b-form-group>

            <b-form-group label="Número de Confirmación">
              <b-form-input v-model="cancelacionData.confirmationNumber" placeholder="Ejemplo: 3105" required
                v-b-tooltip.hover.top="'Número de confirmación otorgado al programar la recolección'" />
            </b-form-group>

            <b-form-group label="Fecha de Recolección">
              <b-form-input type="date" v-model="pickupDateFormatted" placeholder="Selecciona la fecha programada"
                required v-b-tooltip.hover.top="'Fecha en la que se programó la recolección'" />
            </b-form-group>

            <b-form-group label="Código de Localización">
              <b-form-input v-model="cancelacionData.location" placeholder="Ejemplo: LOC-1234" required
                v-b-tooltip.hover.top="'Código de ubicación o sucursal donde se programó la recolección'" />
            </b-form-group>

            <div class="text-right mt-4">
              <b-button variant="light" class="mr-2" @click="hideCancelacionModal" :disabled="isCancelling"
                v-b-tooltip.hover.top="'Cerrar el formulario sin cancelar'">
                Cerrar
              </b-button>
              <b-button variant="danger" type="submit" :disabled="isCancelling"
                v-b-tooltip.hover.top="'Confirma la eliminación de la recolección en el sistema'">
                <b-spinner small v-if="isCancelling" label="Cancelando..." />
                <span v-else>Confirmar Cancelación</span>
              </b-button>
            </div>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<<script>
import axios from "axios";
import commons from "../commons";
import Navbar from "./Header/Navbar";

export default {
  name: "Recolecciones",
  components: { NavbarDashboard: Navbar },

  data() {
    return {
      recolecciones: [],
      isLoading: false,
      user_id: localStorage.getItem("ew-user-id") || "",

      showRecoleccionModalState: false,
      showCancelacionModalState: false,

      trackingSearch: "",
      addressFieldsDisabled: false,
      referenceFieldDisabled: false,
      isSettingCarrier: false,

      recoleccionData: this.getDefaultRecoleccion(),

      cancelacionData: {
        carrier: "",
        confirmationNumber: "",
        pickupDate: "",
        location: ""
      },

      recoleccionResponse: null,
      recoleccionError: null,
      cancelacionResponse: null,
      cancelacionError: null,
      isCancelling: false,

      carriers: []
    };
  },
  computed: {
    pickupDateFormatted: {
      get() {
        return this.cancelacionData.pickupDate.split("T")[0] || "";
      },
      set(value) {
        this.cancelacionData.pickupDate = new Date(value).toISOString();
      }
    }
  },
  watch: {
    'recoleccionData.carrier'(newVal) {
      if (this.isSettingCarrier) {
        return;
      }
      this.addressFieldsDisabled = false;
      this.referenceFieldDisabled = false;
    }
  },
  mounted() {
    this.fetchRecolecciones();
    this.fetchCarrierFromShipment();
  },

  methods: {
    fetchCarrierFromShipment() {
      axios.get(`${commons.apiURL}/api/v1/carrier/getCarrierFromShipments`)
        .then(res => {
          this.carriers = res.data.map(item => item.cve);
        })
        .catch(err => console.error(err));
    },
    // Evita mostrar "null" cuando la paquetería no devolvió número de confirmación
    confirmationLabel(r) {
      const parts = [r.location, r.confirmationNumber].filter(v => v && v !== 'null' && v !== 'undefined');
      return parts.length ? parts.join('') : '—';
    },
    formatDate(date) {
      const [year, month, day] = date.split('-');
      const d = new Date(year, month - 1, day);
      return d.toLocaleDateString("es-MX");
    },

    getDefaultRecoleccion() {
      return {
        carrier: "",
        pickupDate: "",
        readyByTime: "",
        closeTime: "",
        specialInstructions: "",
        pickupContact: { personName: "", phone: "", email: "" },
        place: {
          companyName: "",
          numExt: "",
          address1: "",
          address2: "",
          city: "",
          stateSort: "",
          postalCode: "",
          packageLocation: "",
          references: ""
        },
        parcels: [
          { depth: 0, width: 0, height: 0, weight: 0, trackings: "" }
        ]
      };
    },

    async fetchRecolecciones() {
      this.isLoading = true;
      try {
        const { data } = await axios.get(
          `${commons.apiURL}/api/v1/recolecciones?user=${this.user_id}`
        );
        this.recolecciones = data;
      } catch (err) {
        console.error("Error al obtener recolecciones:", err);
      } finally {
        this.isLoading = false;
      }
    },

    agregarParcel() {
      this.recoleccionData.parcels.push({
        depth: 0,
        width: 0,
        height: 0,
        weight: 0,
        trackings: ""
      });
    },

    eliminarParcel(index) {
      this.recoleccionData.parcels.splice(index, 1);
    },

    showRecoleccionModal() {
      this.recoleccionResponse = null;
      this.recoleccionError = null;

      this.trackingSearch = ""; // 🔥 limpiar

      this.showRecoleccionModalState = true;
      this.recoleccionData = this.getDefaultRecoleccion();
    },

    hideRecoleccionModal() {
      this.showRecoleccionModalState = false;
    },

    showCancelacionModal(obj) {
      Object.assign(this.cancelacionData, {
        carrier: obj.carrier,
        confirmationNumber: obj.confirmationNumber,
        pickupDate: obj.pickupDate,
        location: obj.location
      });
      this.cancelacionResponse = null;
      this.cancelacionError = null;
      this.showCancelacionModalState = true;
    },

    hideCancelacionModal() {
      this.showCancelacionModalState = false;
    },

    async eliminarRecoleccion() {
      if (!confirm("¿Seguro que deseas eliminar esta recolección?")) return;

      this.isCancelling = true;

      try {
        const response = await axios.post(
          `${commons.apiURL}/api/v1/cancelar-recoleccion`,
          this.cancelacionData
        );

        if (response.status === 200) {
          this.fetchRecolecciones();
          this.hideCancelacionModal();
        }
      } catch (error) {
        this.handleError(error, "Error al cancelar la recolección");
      } finally {
        this.isCancelling = false;
      }
    },

    async generarRecoleccion() {
      try {
        this.recoleccionData.user = this.user_id;

        const response = await axios.post(
          `${commons.apiURL}/api/v1/generar-recoleccion`,
          this.recoleccionData
        );

        if (response.status === 200) {
          this.fetchRecolecciones();
          this.hideRecoleccionModal();
        }
      } catch (error) {
        this.handleError(error, "Error al generar la recolección");
      }
    },
    async buscarGuia() {
      if (!this.trackingSearch) {
        this.$bvToast.toast("Ingresa un número de guía", {
          variant: "warning",
          solid: true
        });
        return;
      }

      try {
        await this.obtenerDireccionPorGuia(this.trackingSearch);

        this.$bvToast.toast("Dirección y paquetes encontrados y autocompletados.", {
          variant: "success",
          solid: true
        });
      } catch (err) {
        this.addressFieldsDisabled = false;
        this.referenceFieldDisabled = false;

        this.$bvToast.toast("No se encontró información de la guía. Llenar manualmente.", {
          variant: "danger",
          solid: true
        });
      } finally {
      }
    },
    async obtenerDireccionPorGuia(guia) {
      try {
        const res = await axios.get(`${commons.apiURL}/api/v1/shipments/guide/${guia}`);
        // Accedemos a la respuesta principal
        const guideData = res.data;
        // Extraemos originalShipment como base principal de datos
        const original = guideData.originalShipment || {};
        const originDir = original.origin_direction || {};

        this.addressFieldsDisabled = true;

        // 1. Mapeo de Contacto y Dirección
        // Prioridad: originalShipment.origin_direction -> guideData.origin_direction
        this.recoleccionData.pickupContact = {
          personName: originDir.full_name || guideData.origin_direction.full_name || '',
          phone: originDir.phone || guideData.origin_direction.phone || '',
          email: originDir.email || guideData.origin_direction.email || ''
        };

        this.recoleccionData.place = {
          companyName: originDir.companyName || guideData.origin_direction.companyName || '',
          address1: originDir.address || guideData.origin_direction.address || '',
          address2: originDir.colony || guideData.origin_direction.colony || '',
          numExt: originDir.number || '',
          city: originDir.city || guideData.origin_direction.city || '',
          stateSort: originDir.state || guideData.origin_direction.state || '',
          postalCode: originDir.postal_code || guideData.origin_direction.postal_code || '',
          packageLocation: '',
          references: originDir.reference_of_origin || guideData.origin_direction.reference_of_origin || ''
        };

        this.referenceFieldDisabled = originDir.reference_of_origin;

        // Manejo del Carrier (Viene en la raíz del objeto principal)
        if (guideData.selected_service && guideData.selected_service.carrier) {
          this.isSettingCarrier = true;
          this.recoleccionData.carrier = guideData.selected_service.carrier;
          this.$nextTick(() => {
            this.isSettingCarrier = false;
          });
        }

        // 2. Mapeo de Paquetes (Prioridad originalShipment.parcels)
        const parcelsSource = original.parcels || guideData.parcels || [];

        if (parcelsSource.length > 0) {
          const p = parcelsSource[0];

          this.recoleccionData.parcels = p ? [{
            height: p.height || 0,
            width: p.width || 0,
            depth: p.depth || 0,
            weight: p.weight || 0,
            trackings: guia
          }] : [];
        } else if (guideData.number_guide) {
          this.recoleccionData.parcels = [
            { height: 1, width: 1, depth: 1, weight: 1, trackings: guia }
          ];
        } else {
          this.recoleccionData.parcels = [];
        }

      } catch (err) {
        console.error("Error al obtener guia:", err);
        this.addressFieldsDisabled = false;
        this.referenceFieldDisabled = false;
        throw err;
      }
    },

    // =====================================================
    // Manejo de errores (no se toca)
    // =====================================================
    handleError(error, title) {
      console.error(title, error);
      let msg = "Ocurrió un error inesperado.";

      // Normalizar: extrae el JSON tanto si viene de Axios (error.response.data)
      // como si pasas el objeto directamente.
      const errorData = (error && error.response && error.response.data) ? error.response.data : error;

      if (errorData) {
        // Paso 1: Intentar obtener el mensaje general del servidor
        msg = errorData.message || msg;

        const err = errorData.error;

        if (err) {
          // --- CASO ESPECÍFICO PARA TU CUERPO ACTUAL ---
          // Si err es un objeto y tiene una propiedad interna "error" (string)
          if (typeof err === "object" && typeof err.error === "string") {
            msg = err.error;
          }

          // --- CASO PARA ARRAYS DE ERRORES (Formatos estándar) ---
          else if (Array.isArray(err.errors) && err.errors.length) {
            const e = err.errors[0];
            msg = `Código: ${e.code || "ERROR"} - ${e.message || "Error no especificado"}`;
          }

          // --- CASO PARA ERRORES POR CAMPOS (Objetos complejos) ---
          else if (err.errors && typeof err.errors === "object") {
            const fieldErrors = [];
            for (const [field, errors] of Object.entries(err.errors)) {
              const flattenedErrors = Array.isArray(errors)
                ? errors.flat(Infinity)
                : Object.values(errors).flat(Infinity);

              flattenedErrors.forEach(errorMsg => {
                if (typeof errorMsg === "string" && errorMsg.trim())
                  fieldErrors.push(`[${field}]: ${errorMsg}`);
              });
            }
            if (fieldErrors.length > 0) msg = fieldErrors.join("; ");
          }

          // --- CASO SI EL ERROR ES DIRECTAMENTE UN STRING ---
          else if (typeof err === "string") {
            msg = err;
          }
        }
      } else if (error && error.message) {
        msg = error.message;
      }

      // Resultado final
      this.recoleccionError = msg;
      this.$bvToast.toast(msg, {
        title,
        variant: "danger",
        solid: true,
        autoHideDelay: 6000
      });
    }
  }
};
</script>

<style scoped>
.ew-instructions {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Recoleccion.vue